export default __webpack_public_path__ + "static/media/learnmoreaboutelumntphoto.875d141e.jpg";